import type { ReactElement } from 'react';
import type { ManuscriptChapter } from '@xdocs/schemas';
import { Modal, cn } from '@xdocs/ui';
import { useReaderT } from '../../features/reader/useReaderT.js';
import styles from './ReaderChapterDrawer.module.css';

export interface ReaderChapterDrawerProps {
  open: boolean;
  onClose: () => void;
  chapters: readonly ManuscriptChapter[];
  activeChapterId: string | null;
  onSelectChapter: (chapterId: string) => void;
}

/** F66 chapter-jump drawer — focus-trapped list of the current version's
 * chapters, highlighting the one currently being read. */
export function ReaderChapterDrawer({ open, onClose, chapters, activeChapterId, onSelectChapter }: ReaderChapterDrawerProps): ReactElement {
  const { t } = useReaderT();

  return (
    <Modal open={open} onClose={onClose} title={t('reader:chapters.title')} scrollableBody size="sm">
      <ol className={cn(styles['list'])}>
        {chapters.map((chapter) => {
          const active = chapter.id === activeChapterId;
          return (
            <li key={chapter.id}>
              <button
                type="button"
                className={cn(styles['item'], active && styles['itemActive'])}
                aria-current={active ? 'true' : undefined}
                onClick={() => {
                  onSelectChapter(chapter.id);
                  onClose();
                }}
              >
                <span className={cn(styles['itemOrder'])}>{chapter.order + 1}</span>
                <span className={cn(styles['itemTitle'])}>{chapter.title}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </Modal>
  );
}
